/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Series_NameInputs */

const en_us2_body_assessment_series_name = /** @type {(inputs: Body_Assessment_Series_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body fat · photo`)
};

const pt_br2_body_assessment_series_name = /** @type {(inputs: Body_Assessment_Series_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gordura · foto`)
};

const es_419_body_assessment_series_name = /** @type {(inputs: Body_Assessment_Series_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grasa corporal · foto`)
};

const pt_pt2_body_assessment_series_name = /** @type {(inputs: Body_Assessment_Series_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gordura · foto`)
};

const fr_fr2_body_assessment_series_name = /** @type {(inputs: Body_Assessment_Series_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masse grasse · photo`)
};

const de_de2_body_assessment_series_name = /** @type {(inputs: Body_Assessment_Series_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körperfett · Foto`)
};

const it_it2_body_assessment_series_name = /** @type {(inputs: Body_Assessment_Series_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grasso · foto`)
};

/**
* | output |
* | --- |
* | "Body fat · photo" |
*
* @param {Body_Assessment_Series_NameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_series_name = /** @type {((inputs?: Body_Assessment_Series_NameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Series_NameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_series_name(inputs)
	if (locale === "es-419") return es_419_body_assessment_series_name(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_series_name(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_series_name(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_series_name(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_series_name(inputs)
	return en_us2_body_assessment_series_name(inputs)
});
export { body_assessment_series_name as "body-assessment.series_name" }